var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["widget-step wallet-step", { active: _vm.isActiveStep }],
      attrs: { "data-test-id": "fill-wallet-address" }
    },
    [
      _c(
        "StepTitle",
        {
          attrs: { stepNumber: _vm.stepNumber },
          nativeOn: {
            click: function($event) {
              return _vm.$emit("setStep", _vm.stepNumber)
            }
          }
        },
        [_vm._v("\n    " + _vm._s(_vm.i18n.wallet_step_title()) + "\n  ")]
      ),
      _vm._v(" "),
      _vm.isActiveStep
        ? _c("AccordeonWrapper", [
            _c(
              "div",
              { staticClass: "widget-step__inner" },
              [
                _c("input-field", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value:
                        "required|" +
                        _vm.addressRuleFor(_vm.selectedAssetWithoutSpace),
                      expression:
                        "`required|${addressRuleFor(selectedAssetWithoutSpace)}`"
                    }
                  ],
                  staticClass: "field__wallet",
                  attrs: {
                    "data-test-id": "fill-wallet-address-input",
                    autocomplete: false,
                    label: "",
                    name: _vm.selectedAssetWithoutSpace,
                    id: _vm.selectedAssetWithoutSpace,
                    autofocus: true,
                    errorMessage: _vm.errors.first(
                      _vm.selectedAssetWithoutSpace
                    )
                  },
                  model: {
                    value: _vm.walletAddress,
                    callback: function($$v) {
                      _vm.walletAddress =
                        typeof $$v === "string" ? $$v.trim() : $$v
                    },
                    expression: "walletAddress"
                  }
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "validation-error",
                    attrs: { "data-test-id": "fill-wallet-address-input-error" }
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.validationErrors) + "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "btn-container" },
                  [
                    _c(
                      "md-button",
                      {
                        staticClass: "btn md-mint",
                        attrs: {
                          type: "button",
                          disabled: false,
                          "data-test-id": "fill-wallet-address-btn"
                        },
                        on: { click: _vm.onClickHandler }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.i18n.withdraw_withdraw()) +
                            "\n        "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04afdd6d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04afdd6d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/dashboard/widgets/WithdrawalWidget/FillWalletAddress.vue
// module id = qvje
// module chunks = 1